<template>
  <!--弹框2 开始-->
  <el-dialog :visible.sync="frameHotelSoldDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center class="textcenter">
    <div style="width:100%;text-align: center;">
      <div><img src="https://res.roompai.com/static/img/frame/fail.png" class="frame-big-img"></div>
      <div class="frame-text-hotel-sold wordBreak">
        {{$t('noRooms')}}
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button class="dialog-goback" @click="cityRouterLink">{{$t('backHome')}}</el-button>
    </span>
  </el-dialog>
  <!--弹框2 结束-->
  <!--引入方式-->
  <!-- <frameHotelSold :frameHotelSoldDialog="frameHotelSoldDialog"></frameHotelSold> -->
</template>

<script>
import { getCityId } from '@/request/hotel.js'
export default {
  name: 'frameHotelSold',
  props: ['frameHotelSoldDialog', 'checkIn', 'checkOut'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false,
      city: {},
      adult: 2,
      child: 0,
      room: 1,
      startdate: '',
      enddate: '',
      hotelid: '',
      source: 'roompai',
      conver: ''
    }
  },
  created () {
    var query = this.common.linkQuerys
    if (JSON.stringify(query) !== '{}') {
      this.adult = parseInt(this.common.linkQuerys.adult)
      this.child = parseInt(this.common.linkQuerys.child)
      this.room = parseInt(this.common.linkQuerys.room)

      this.startdate = this.common.linkQuerys.start_date
      this.enddate = this.common.linkQuerys.end_date
    } else {
      var params = this.$route.params
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
      }
      if (JSON.stringify(params) !== '{}' || (searchData !== '{}' && searchData !== null)) {
        this.adult = parseInt(params.adult)
        this.child = parseInt(params.child)
        this.room = parseInt(params.room)
        this.startdate = params.start_date
        this.enddate = params.end_date
      }
    }
    // 获取城市ID
    this.getCityIdFun()
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    var conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
  },
  methods: {
    // 获取城市ID
    getCityIdFun: function () {
      var query = this.common.linkQuerys
      if (JSON.stringify(query) !== '{}' && query.hotelid !== undefined) {
        this.hotelid = this.common.linkQuerys.hotelid
      } else {
        var params = this.$route.params
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
        }
        this.hotelid = params.hotelid
      }

      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      var DataJson = {'hotelid': this.hotelid, 'operation': 'getCityId', 'time': time, 'sessionid': sessionid}
      var Data = this.common.encryptionData(DataJson, this)
      getCityId(Data).then(res => {
        console.log('frameHotelSold  city返回')
        console.log(res.data.hotelCity)
        this.city = res.data.hotelCity
      })
    },
    // 城市跳转
    cityRouterLink: function () {
      // 点击返回首页 埋点记录
      this.clickPageAction('back_home', '', {'type': 'frameHotelSold'})

      var regionSel = {'value_en': this.city.city, 'value_zh': this.city.chinese_name, 'type_id': 1, 'type_data_id': this.city.id}
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      var cityname = this.city.city
      if (this.common.languageSet(this) === 'zh') {
        cityname = this.city.chinese_name
      }

      let d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth()
      var tian = d.getDate()
      var monthSelect = (month + 1) < 10 ? '0' + (month + 1).toString() : (month + 1).toString()
      var startDate = this.startdate
      if (this.startdate === '' || this.startdate === undefined) {
        startDate = year + '-' + monthSelect + '-' + (parseInt(tian) + 1)
      }
      var endDate = this.enddate
      if (this.enddate === '' || this.enddate === undefined) {
        endDate = year + '-' + monthSelect + '-' + (parseInt(tian) + 2)
      }

      var params = this.$route.params
      if (JSON.stringify(params) === '{}') {
        params = this.common.linkQuerys
      }
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
      }
      var childNums = '[]'
      if (JSON.stringify(params) !== '{}' && JSON.stringify(params.childNums) !== '{}' && params.childNums !== undefined) {
        childNums = params.childNums
      }
      if (JSON.stringify(params) !== '{}' && JSON.stringify(params.start_date) !== '' && JSON.stringify(params.start_date) !== undefined && JSON.stringify(params.end_date) !== '' && JSON.stringify(params.end_date) !== undefined) {
        startDate = params.start_date
        endDate = params.end_date
      }
      if (this.checkIn !== null && this.checkIn !== undefined) {
        startDate = this.checkIn
        endDate = this.checkOut
      }
      var searchJson = {'type': 1, 'type_id': this.city.id, 'region': cityname, 'start_date': startDate, 'end_date': endDate, 'room': params.room, 'adult': params.adult, 'child': params.child, 'childNums': childNums}
      if (this.source !== '' && this.source !== 'roompai' && this.source !== undefined && this.source !== null) {
        searchJson['source'] = this.source
      }
      if (this.conver === 1 || this.conver === '1') {
        searchJson['conver'] = this.conver
      }
      localStorage.setItem('searchData', JSON.stringify(searchJson))
      // this.$router.push({name: 'HotelList', query: searchJson})
      var newQuerys = this.common.linkEncode(searchJson, 'obj')
      this.$router.push({name: 'HotelList', params: {'querys': newQuerys}})
    }
  }
}
</script>

<style scoped>
.textcenter{text-align: center;}
.frame-big-img{width:100px; height:100px;cursor: pointer;}
.frame-text-hotel-sold{height:20px; font-size: 16px;color: #4F4C4C;text-align: center;}
.dialog-goback{width: auto;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;cursor:pointer;}
.dialog-goback:hover,.dialog-goback:focus{ background:rgba(252, 210, 5, 1);color:#4F4C4C;border: 1px solid rgba(252, 210, 5, 1);}
.textcenter /deep/ .el-dialog{background: url(https://res.roompai.com/static/img/frame/sold-ch.png) no-repeat;background-position: right bottom; background-color: #fff;background-size: 23%;}
@media screen and (max-width: 1000px) {
.dialog-goback{width:100%; margin-bottom: 10px;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/frameHotelSold.vue